import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { logout } from "../actions/auth";
import { connect } from "react-redux";

const Nav = ({ auth: { isAuthenticated, loading }, logout, onClick }) => {
  const authLinks = (
    <ul className="navbar-nav mr-auto">
      <li className="nav-item">
        <Link className="nav-link" to="/problems">
          Problems <span className="sr-only">(current)</span>
        </Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link" to="/comingsoon">
          Contests
        </Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link" to="/comingsoon">
          Articles
        </Link>
      </li>

      <li className="nav-item mt-2">
        <Link to="/profile" style={{ textDecorationLine: "none" }}>
          <i className="fas fa-user" /> <span>Profile</span>
        </Link>
      </li>
      <li className="nav-item mt-2">
        <a onClick={logout} href="" style={{ textDecorationLine: "none" }}>
          <i className="fas fa-sign-out-alt"></i> <span>Logout</span>
        </a>
      </li>
    </ul>
  );
  const guestLinks = (
    <Link to="/register" className="btnn">
      Register/Signin
    </Link>
  );
  return (
    <div className="container-fluid sticky-top">
      <div className="row">
        <div className="col-12 mx-auto">
          <nav className="navbar navbar-expand-md navbar-light">
            <Link className="navbar-brand" to="/">
              <img src={require("../images/logo.png")} alt="Logo" />
            </Link>
            {/* <input type='checkbox' name='theme' id='switch' onClick={onClick} />
            <label htmlFor='switch'>Toggle</label> */}
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              {!loading && <>{isAuthenticated ? authLinks : guestLinks}</>}
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

Nav.propTypes = {
  logout: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logout })(Nav);
